import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color } from '../constants'
import { StyleProps, createStyles } from '../utils/create-styles'

export type ClickableProps = {
  children?: ReactNode
  styles?: StyleProps
  hoverBackgroundColor?: Color
}

export const Clickable = styled('button', {
  shouldForwardProp: (prop) =>
    prop !== 'styles' && prop !== 'hoverBackgroundColor',
})<ClickableProps>((props) => {
  return {
    // Reset styles to a plain div
    all: 'unset',
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',

    // Cursor
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'not-allowed',
    },
    ...(props.hoverBackgroundColor && {
      '&:hover': {
        backgroundColor: props.hoverBackgroundColor,
      },
    }),
    ...createStyles(props.styles),
  }
})
